import { ISliderProps, Slider } from '@fluentui/react/lib/Slider';

export interface IPSliderProps extends ISliderProps {}

export const IPSlider = (props: IPSliderProps) => {
  return <Slider {...props} />;
};
